<template>
  <SbIcon
    variation="icon_padlock"
    v-on="$attrs"
  />
</template>

<script>
import SbIcon from '@src/components/Icons/SbIcon.vue';

export default {
  name: 'PadlockIcon',
  components: { SbIcon },
};
</script>

<style lang='scss'>
</style>
